import { updateTokens } from '@dyl/apiClients/backendApi';
import { useCallback } from 'react';

export default function useTokenDisable() {
    return useCallback(
        /**
         * @param {string[]} selectedIds
         */
        async function disableTokens(selectedIds, level_id) {
            await updateTokens({}, selectedIds,level_id, 'DISABLED');
        }, []
    );
}